export const getStatusBadgeClass = (status) => {
  switch (status) {
    case 'PLACED': return 'status-badge status-placed';
    case 'APPROVED': return 'status-badge status-approved';
    case 'READY_TO_DISPATCH': return 'status-badge status-ready';
    case 'DISPATCHED': return 'status-badge status-dispatched';
    default: return 'status-badge';
  }
};

export const getStatusText = (status, t = null) => {
  if (t) {
    switch (status) {
      case 'PLACED': return t('status.placed');
      case 'APPROVED': return t('status.approved');
      case 'READY_TO_DISPATCH': return t('status.readyToDispatch');
      case 'DISPATCHED': return t('status.dispatched');
      default: return status;
    }
  }
  
  // Fallback to English if no translation function provided
  switch (status) {
    case 'PLACED': return 'Placed';
    case 'APPROVED': return 'Approved';
    case 'READY_TO_DISPATCH': return 'Ready to Dispatch';
    case 'DISPATCHED': return 'Dispatched';
    default: return status;
  }
}; 